// extracted by mini-css-extract-plugin
export default {"container":"Body_container__TCykS","loading":"Body_loading__Teix4","logo":"Body_logo__P09PT"};